import PropTypes from 'prop-types';

import withTranslation from 'lib/shared/i18n/withTranslation';
import BaseField from 'components/Fields/BaseField/BaseField';

class RegexTextField extends BaseField {
  static propTypes = {
    errorMessageKey: PropTypes.string.isRequired,
    regex: PropTypes.instanceOf(RegExp).isRequired,
    value: PropTypes.string,
  };

  isValid(value) {
    if (value && !this.props.regex.test(value)) {
      return false;
    }

    return super.isValid(value);
  }

  getValidationError() {
    const { t, value, errorMessageKey } = this.props;

    // If we have a value, and are invalid, that means we got a incorrect string
    if (value) {
      return t(errorMessageKey);
    }

    return super.getValidationError();
  }
}

export default withTranslation()(RegexTextField);
